import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import {
  FIRST_SEND_THRESHOLD,
  GALLERY_FIRST_SEND_PARAM,
  parseFirstSendCopy,
  type FirstSendCopy,
} from "../gallery/firstSendMock";
import { formatLabeledAmount } from "../utils";

/** `null` outside the first-send variant of a Transfer screen. */
export const useGalleryFirstSend = (): FirstSendCopy | null => {
  const [searchParams] = useSearchParams();
  return parseFirstSendCopy(searchParams.get(GALLERY_FIRST_SEND_PARAM));
};

export const useFirstSendWarningCopy = (copy: FirstSendCopy = "default") => {
  const { t } = useTranslation("firstSend");
  const amount = formatLabeledAmount(
    FIRST_SEND_THRESHOLD.amount,
    FIRST_SEND_THRESHOLD.currency,
  );
  return {
    title: t(copy === "long" ? "warning.longTitle" : "warning.title", {
      amount,
    }),
    body: t(copy === "long" ? "warning.longBody" : "warning.body"),
  };
};
